import { TableCell, TableHead, TableRow } from "@mui/material";
import React from "react";
import { menuTableCellHeader } from "../../../../Constants/MockData";
import { tableLabelStyle } from "../../../../Utils/CommonStyles/muTableStyle";
import Fonts from "../../../../Config/Fonts";
import Colors from "../../../../theme/Colors";

const MenuTableHeader = () => {
  return (
    <TableHead>
      <TableRow>
        {menuTableCellHeader?.map((tCell, index) => (
          <TableCell
            key={index}
            style={{
              fontSize: 12,
              fontWeight: "500",
              fontFamily: Fonts.Poppins,
              color: Colors.white,
              position: "sticky",
              top: 0,
              textAlign: "center",
              padding: "12px 5px",
              border: "1px solid #E6E6E6",
              backgroundColor: Colors.adminPrimaryColor,
            }}
          >
            {tCell?.header}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default MenuTableHeader;
